.l{display:flex;}